import {SwalFunction} from "../SwalFunction.ts";
import {apiResponseHandler} from "../../../utils/functions/apiResponseHandler.ts";
import {axiosFunction} from "../axiosFunction.ts";
import {v2ReactURL} from "../../../utils/constant.ts";
import {toastMessage} from "../ToasterMessage.ts";
import { ErrorState } from "../../../pages/Contact/MainDataTable.tsx";
// import {ErrorState} from "../../../pages/Contact/Contact.tsx";

export async function deleteCampaign(loyaltyCampaignId: number | null) {
    const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        {icon: "warning"}
    );

    if (result.isConfirmed) {
        const res = await axiosFunction(
            `${v2ReactURL}/loyalty/campaign/${loyaltyCampaignId}`,
            "DELETE"
        );

        const error: ErrorState | null = apiResponseHandler(res, true);
        if (error != null) {
            toastMessage(error.message);
            return false;
        }
        return true;
    }
    return false;
}